export default {
  SET_OPERATIONS (state, operations) {
    state.operations = operations
  },
  SET_OPERATIONPRODUCTS (state, operationproducts) {
    state.operationproducts = operationproducts
  },
  CREATE_OPERATIONS_PRODUCTS (state, item) {
    state.operationproducts.unshift(item)
  },
  UPDATE_OPERATIONPRODUCTS (state, operationproduct) {
    const productIndex = state.operationproducts.findIndex((p) => p.id === operationproduct.id)
    Object.assign(state.operationproducts[productIndex], operationproduct)

    /*const ItemIndex = this.operation_data.products.findIndex((p) => p.id === obj.idproduct)
    Object.assign(state.operationproducts[ItemIndex], product)*/
  },
  REMOVE_OPERATIONPRODUCTS (state, productId) {
    alert(productId)
    const ItemIndex = state.operationproducts.findIndex((p) => p.id === productId)
    alert(ItemIndex)
    state.operationproducts.splice(ItemIndex,1)
  },
  SET_OPERATION (state, operation) {
    state.operation = operation
  },
  UPDATE_OPERATION (state, operation) {
    const operationIndex = state.operations.findIndex((p) => p.id === operation.id)
    Object.assign(state.operations[operationIndex], operation)
  },
  CREATE_OPERATION (state, operation) {
    state.operation = operation
  }
}
